<template>
<!-- 
xs(Extra Small)・・・主にスマホ対応
sm(Small)・・・主にタブレット
md(Medium) ・・・主にノートパソコンや横表示のタブレット
lg(Large)・・・主にデスクトップ
xl(Extra large)・・・4Kや大きなモニター 


v-if="$vuetify.breakpoint.xs"
-->
    <v-container fluid>
        <v-row dense >
            <Title title="知識バンク(β版)" />
        </v-row>
        <v-row dense>
            <v-card outlined class="mt-1" width="100%">
                <v-toolbar dense flat class="mb-1">
                    <v-menu offset-y transition="slide-x-transition" position-x="0">
                        <template v-slot:activator="{ on }">
                            <v-btn small icon v-on="on" ref="btnShowTree">
                                <v-icon>mdi-file-tree</v-icon>
                            </v-btn>
                        </template>
                        <v-list dense>
                            <v-list-item>
                                <v-list-item-content>
                                    <Title title="知識ツリー" dense />
                                    <v-treeview
                                        ref="tree" 
                                        :items="treeItems" 
                                        dense                                    
                                        item-key="knowledge.knowledgeID"
                                        item-children="children"
                                        :open.sync="treeOpenKeys"
                                        @update:open = "onOpenTreeItem" >
                                        <template slot="label" slot-scope="data">
                                            <v-chip label :color="selectedTreeItem != null && selectedTreeItem.knowledge.knowledgeID == data.item.knowledge.knowledgeID ? 'teal lighten-5' : 'white'" @click.stop="onClickTreeItem(data)">
                                                {{data.item.knowledge.title}}
                                                <v-progress-circular
                                                    v-if="data.item.isSearchingChildren"
                                                    indeterminate
                                                    size="16"
                                                    color="green"
                                                    class="ma-3"
                                                    />
                                            </v-chip>
                                        </template>
                                        <template v-slot:prepend="{item, open}">
                                            <v-icon v-if="item.type=='new'">mdi-playlist-edit</v-icon>
                                            <v-icon v-else>mdi-file-document-outline</v-icon>
                                        </template>
                                    </v-treeview>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                    <v-btn icon @click="isEditMode = !isEditMode" :color="isEditMode ? 'primary' : ''"><v-icon>mdi-pencil</v-icon></v-btn>
                    <v-fab-transition>
                        <v-chip v-if="isEditMode" label color="primary" outlined>編集モード</v-chip>
                    </v-fab-transition>
                    <v-spacer />
                    <v-tooltip bottom color="teal lighten-4 black--text">
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                class="mt-4"
                                v-bind="attrs"
                                v-on="on"
                                v-model="searchWord" 
                                clearable 
                                label="知識の検索" 
                                type="text"
                                dense
                                hide-details
                                append-icon="mdi-text-box-search-outline"
                                @click:append="onClickSearch" />
                        </template>
                        スペースで区切って、複数の単語を指定出来ます。
                    </v-tooltip>
                    <!-- <v-spacer />
                    <v-text-field
                        dense
                        outlined
                        hide-details
                        label="検索"
                        append-icon="mdi-magnify"
                        /> -->
                </v-toolbar>
            </v-card>
        </v-row>
        <v-scale-transition>
            <v-row dense v-if="searchedKnowledges.length > 0">
                <v-card class="mt-1 pa-2" width="100%">
                    <v-toolbar flat dense height="20">
                        検索結果
                        <v-spacer />
                        <v-btn icon color="primary" @click="onClickCloseSearchResult"><v-icon>mdi-close-circle-outline</v-icon></v-btn>
                    </v-toolbar>
                    <template v-for="knowledge in searchedKnowledges">
                        <!-- <v-chip label :key="knowledge.knowledgeID" class="ma-1" color="primary" @click="onClickSearchedKnowledge(knowledge)">
                            {{knowledge.title}}
                        </v-chip> -->
                        <v-btn text :key="knowledge.knowledgeID" class="ma-1" color="primary" @click="onClickSearchedKnowledge(knowledge)">
                            ・{{knowledge.title}}
                        </v-btn>
                    </template>
                </v-card>
            </v-row>
        </v-scale-transition>
        <v-row dense>
            <v-breadcrumbs v-if="!$vuetify.breakpoint.xs" class="pa-1 mt-1 mb-1">
                <template v-slot:divider>
                    <v-icon>mdi-forward</v-icon>
                </template>
                <v-breadcrumbs-item v-for="item in selectedTreeItemPaths" :key="item.treeItem.knowledge.knowledgeID" >
                    <template v-if="item.treeItem.children != null">
                        <v-menu offset-x close-on-content-click transition="slide-x-transition">
                            <template v-slot:activator="{ on }">
                                <v-chip small label @click="onSelectedTreeItem(item.treeItem)" color="primary" v-on="on">
                                    <v-icon v-if="item.treeItem.knowledge.lock">mdi-lock</v-icon>
                                    {{item.text}}
                                </v-chip>
                            </template>
                            <v-list dense>
                                <v-list-item v-for="child in item.treeItem.children" :key="child.knowledge.knowledgeID" @click="onSelectedTreeItem(child)">
                                    <v-list-item-icon><v-icon>{{child.type == "new" ? "mdi-playlist-edit" : "mdi-file-document-outline"}}</v-icon></v-list-item-icon>
                                    <v-list-item-content>{{child.knowledge.title}}</v-list-item-content>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </template>
                    <template v-else>
                        <v-chip small label @click="onSelectedTreeItem(item.treeItem)" color="primary">
                            <v-icon v-if="item.treeItem.knowledge.lock">mdi-lock</v-icon>
                            {{item.text}}
                        </v-chip>
                    </template>
                </v-breadcrumbs-item>
            </v-breadcrumbs>

            <v-expand-transition>
                <v-col v-if="selectedTreeItem != null && selectedTreeItem.type == 'knowledge' && !canEdit(selectedTreeItem)" cols="12">
                    <v-card>
                        <v-container fluid>
                            <v-row dense>
                                <v-col>
                                    <table>
                                        <tr v-if="isEditMode && selectedTreeItem.knowledge.lock">
                                            <td style="background-color:yellow; foreground-color:black" colspan="2" class="pa-1">
                                                <v-icon>mdi-lock</v-icon>この知識はロックされているので、編集出来ません。
                                            </td>
                                        </tr>
                                        <tr>
                                            <td style="width:100%">
                                                <div style="white-space:normal" v-html="'<h1>'+selectedTreeItem.knowledge.title+'</h1>'" />
                                            </td>
                                            <td style="vertical-align:bottom" rowspan="2">
                                                <v-tooltip
                                                    v-if="$vuetify.breakpoint.xs"
                                                    v-model="isShowKnowledgeInfo"
                                                    open-on-click
                                                    bottom
                                                    color="teal lighten-4 black--text">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-icon
                                                            v-bind="attrs" 
                                                            v-on="on">
                                                            mdi-information-outline
                                                        </v-icon>
                                                    </template>
                                                    <table>
                                                        <tr>
                                                            <td>
                                                                <v-avatar class="ma-0" size="32" rounded>
                                                                    <v-img v-if="selectedTreeItem.userInfo.avaterURL == null" src="@/assets/no_avater_image.png"/>
                                                                    <v-img v-if="selectedTreeItem.userInfo.avaterURL != null" :src="selectedTreeItem.userInfo.avaterURL"/>
                                                                </v-avatar>
                                                            </td>
                                                            <td >
                                                                {{selectedTreeItem.userInfo.userName}}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td></td>
                                                            <td style="font-size:x-small; text-align:right">
                                                                {{selectedTreeItem.knowledge.writer.dateTime}}
                                                            </td>
                                                        </tr>
                                                    </table>
                                                </v-tooltip>
                                                <table v-else>
                                                    <tr>
                                                        <td>
                                                            <v-avatar class="ma-0" size="32" rounded>
                                                                <v-img v-if="selectedTreeItem.userInfo.avaterURL == null" src="@/assets/no_avater_image.png"/>
                                                                <v-img v-if="selectedTreeItem.userInfo.avaterURL != null" :src="selectedTreeItem.userInfo.avaterURL"/>
                                                            </v-avatar>
                                                        </td>
                                                        <td >
                                                            {{selectedTreeItem.userInfo.userName}}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td></td>
                                                        <td style="text-align:right">
                                                            {{selectedTreeItem.knowledge.writer.dateTime}}
                                                        </td>
                                                    </tr>
                                                </table>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <v-chip label x-small>
                                                第{{selectedTreeItem.knowledge.editionNo}}版
                                                </v-chip>
                                            </td>
                                        </tr>
                                    </table>
                                    <v-divider class="mb-3" />                                
                                    <div 
                                        v-if="selectedTreeItem.knowledge.content != null" 
                                        v-html="selectedTreeItem.knowledge.content" 
                                        style="width:100%; overflow:scroll" />
                                    <div v-else class="mt-3">
                                        ここには、まだどなた様からも知識のご提供がありません。<br/>{{selectedTreeItem.knowledge.title}}の知識をお持ちでしたら、是非記載をお願いします。
                                    </div>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <v-divider class="mb-3" />
                                    <div v-for="comment in selectedTreeItem.comments" :key="comment.body.commentNo">
                                        <div class="d-flex flex-no-wrap">
                                            <v-avatar class="ml-2" rounded>
                                                <v-img v-if="comment.writerInfo.avaterURL == null" src="@/assets/no_avater_image.png"/>
                                                <v-img v-if="comment.writerInfo.avaterURL != null" :src="comment.writerInfo.avaterURL"/>
                                            </v-avatar>
                                            <div class="balloon2-left" style="margin-top:0px; margin-right:10px; width:100%">
                                                <v-card-text class="pa-1">
                                                    <div class="subtitle-2 font-weight-bold mb-1">
                                                        (第{{comment.body.knowledgeEditionNo}}版へのコメント)<br/>
                                                        {{comment.writerInfo.userName}}
                                                    </div>
                                                    <div class="body-2 mb-1" v-html="comment.body.comment.replace(/\r?\n/g, '<br>')" />
                                                    <div class="caption text-right">{{comment.body.writer.dateTime}}</div>
                                                </v-card-text>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="d-flex flex-no-wrap">
                                        <v-avatar class="ml-2 mt-2" rounded>
                                            <v-img v-if="loggedInUserData.avaterImage != null" :src="loggedInUserData.avaterImage.url" />
                                            <v-img v-if="loggedInUserData.avaterImage == null" src="@/assets/no_avater_image.png"/>
                                        </v-avatar>
                                        <v-textarea
                                            v-model="comment"
                                            label="コメント"
                                            rows="2"
                                            clearable
                                            solo
                                            flat
                                            auto-grow
                                            hide-details
                                            dense
                                            class="mt-2 balloon2-left mr-2"
                                            :append-icon="comment != null && comment.trim().length > 0 ? 'mdi-send' : ''"
                                            @click:append="onClickSendNewComment">
                                        </v-textarea>
                                    </div>
                                </v-col>
                            </v-row>
                        </v-container>
                        <v-divider />
                        <v-toolbar flat dense class="mb-1">
                            <v-btn color="blue" icon elevation="0" @click="onClickNice"><v-icon large>mdi-thumb-up</v-icon></v-btn>
                            <v-badge v-if="selectedTreeItem.niceNum > 0" color="blue white--text" :content="selectedTreeItem.niceNum+' 人がいいねしました'" class="mr-3" offset-x="0" offset-y="12" />
                        </v-toolbar>
                    </v-card>
                </v-col>            
            </v-expand-transition>

            <v-expand-transition>
                <v-col v-if="selectedTreeItem != null && canEdit(selectedTreeItem)" cols="12">
                    <v-divider />
                    <v-container fluid>
                        <v-row>
                            <v-col>
                                <v-btn color="teal white--text" block @click="onClickRegistKnowledge" large><v-icon>mdi-floppy</v-icon>この知識を知識バンクに登録</v-btn>
                            </v-col>
                        </v-row>
                        <v-row >
                            <v-col>
                                <v-text-field 
                                    v-model="editItems.title" 
                                    clearable 
                                    label="記事のタイトル" 
                                    outlined 
                                    type="text" 
                                    dense
                                    hide-details />
                            </v-col>
                        </v-row>
                        <v-row >
                            <v-col>
                                <v-text-field 
                                    v-model="editItems.titleKana" 
                                    clearable 
                                    label="タイトルの読み" 
                                    outlined 
                                    type="text" 
                                    dense
                                    hide-details />
                            </v-col>
                        </v-row>
                        <v-row >
                            <v-col cols="12">
                                <quillEditor
                                    ref="editor"
                                    v-model="editItems.content"
                                    :options="editorOptions"                                
                                    />
                            </v-col>
                        </v-row>
                    </v-container>
                </v-col>
            </v-expand-transition>
        </v-row>
        <Confirm ref="confirm" />
    </v-container>
</template>

<script>
    Date.prototype.toFormatString = function (format) {
        const year = this.getFullYear()
        const month = this.getMonth() + 1
        const month2 = ("0" + month).slice(-2)
        const day2 = ("0" + this.getDate()).slice(-2)
        const hour2 = ("0" + this.getHours()).slice(-2)
        const minute2 = ("0" + this.getMinutes()).slice(-2)
        const second2 = ("0" + this.getSeconds()).slice(-2)

        const formattedValue = format.replace("yyyy", year).replace("MM", month2).replace("dd", day2).replace("HH", hour2).replace("mm", minute2).replace("ss", second2)

        return formattedValue
    }

    import Confirm from '@/components/tools/ConfirmDialog';
    import 'quill/dist/quill.core.css'
    import 'quill/dist/quill.snow.css'
    import 'quill/dist/quill.bubble.css'
    import { quillEditor } from 'vue-quill-editor'
    import db from '@/firebase/firestore.js'
    import Title from '@/components/seedling/items/TitleBar'

    export default {
        components: {
            Confirm,
            quillEditor,
            Title
        },
        data: function () {
            return {
                /** ツリーにセットされている全項目を格納する配列(1次元) */
                items: null,
                /** ツリーに表示する全項目の配列(こちらはツリー構造で格納されている) */
                treeItems: [],
                /** ツリーで選択されている項目 */
                selectedTreeItem: null,
                /** 記事の編集項目 */
                editItems: {
                    title: null,
                    titleKana: null,
                    content: null,
                    lock: false,
                    orderNo: 100
                },
                /** 編集モード時は、True */
                isEditMode: false,
                /** 選択項目のパス(Breadcrumbs用) */
                selectedTreeItemPaths: [],
                /** 記事の情報の表示 */
                isShowKnowledgeInfo: false,
                /** エディターのオプション */
                editorOptions: {
                    theme: "snow",
                    placeholder: "ここであなたの知識の入力・編集が行えます。",
                    readOnly: false
                },
                /** 子知識が展開されている全知識の知識IDが格納される配列 */
                treeOpenKeys: [],
                /** 入力されたコメント */
                comment: null,
                /** 検索に入力されたテキスト */
                searchWord: null,
                /** 検索に該当する全知識が格納される配列 */
                searchedKnowledges: []
            }
        },
        computed: {
            /**
             * ログイン中のユーザーのUID
             */
            loggedInUserUID: function () {
                return this.$store.getters["loggedInUserUID"]
            },
            /**
             * ログイン中のユーザーデータ
             */
            loggedInUserData: function () {
                return this.$store.getters["loggedInUserData"]
            },
        },
        created: function () {
            const self = this
            this.items = []
            this.treeItems = []
            this.selectedTreeItem = null
            // this.setChildren(null, this.createNewKnowledgeItem)
            this.setChildren(null, this.createNewKnowledgeItem)
        },
        mounted: function () {
            // 強制的にツリーを表示する
            this.$refs.btnShowTree.$el.click()
        },
        methods: {
            /**
             * 検索ボタン押下時
             */
            onClickSearch: function () {
                console.log("onClickSearch")
                const self = this
                // 入力された文字列をスペースで分割
                const words = this.searchWord.split(" ")
                console.log("search words", words)
                // タグを検索
                db.collection("knowledge_tags").where("tag", "in", words).get().then(function(refTags){
                    // 結果を格納する配列を初期化
                    self.searchedKnowledges = []
                    const knowledgeIDList = []
                    console.log(self.searchedKnowledges)
                    refTags.forEach(function(docTag){
                        // タグに設定されている知識IDから、知識データを取得
                        // (但し、既に取得されている知識データは取得しない)
                        const tag = docTag.data()
                        if (knowledgeIDList.findIndex((v)=>v == tag.knowledgeID) < 0) {
                            console.log("search knowledge", tag.knowledgeID)
                            knowledgeIDList.push(tag.knowledgeID)
                            db.collection("knowledges").doc(tag.knowledgeID).get().then(function(doc){
                                self.searchedKnowledges.push(doc.data())
                            }).catch(function(error){
                                console.log(error)
                                self.$store.commit("notification", {message:"検索に失敗しました。", isError: true})
                                self.mi_writeLog("KnowledgeBankManager/onClickSearch", "検索に失敗しました。(1)("+error+")")
                            })
                        }
                    })
                }).catch(function(error){
                    console.log(error)
                    self.$store.commit("notification", {message:"検索に失敗しました。", isError: true})
                    self.mi_writeLog("KnowledgeBankManager/onClickSearch", "検索に失敗しました。(2)("+error+")")
                })
            },
            /**
             * 検索結果の知識を押下時
             */
            onClickSearchedKnowledge: function (knowledge) {
                console.log("onClickSearchedKnowledge", knowledge)
                const self = this
                // 既に取得されているツリー項目の知識であれば、そこから取得して終了
                const treeItem = this.items.find((v)=>v.knowledge.knowledgeID == knowledge.knowledgeID)
                if (treeItem != null) {
                    this.selectedTreeItem = treeItem
                    return
                }
                // まだ取得されていないツリー項目の知識の時
                // 一番知識の知識から順次ツリー項目を作成していく
                const knowledgeIDList = knowledge.knowledgeID.split("-")
                var childNo = 0
                const finder = function (knowledgeID) {
                    console.log("finder", knowledgeID)
                    const targetTreeItem = self.items.find((v)=>v.knowledge.knowledgeID == knowledgeID)
                    if (targetTreeItem == null) {
                        console.log("(finder)child none")
                        return
                    }
                    const next = function () {
                        childNo++
                        var nextID = ""
                        for (var i=0; i<=childNo; i++) {
                            nextID+=(knowledgeIDList[i] + (i<childNo ? "-" : ""))
                        }
                        console.log("next", nextID)
                        const child = targetTreeItem.children.find((v)=>v.knowledge.knowledgeID == nextID)
                        if (child == null) {
                            console.log("(next)child none")
                            return
                        }
                        if (child.knowledge.knowledgeID == knowledge.knowledgeID) {
                            self.onSelectedTreeItem(child)
                            console.log("(next)completed")
                        } else {
                            finder(child.knowledge.knowledgeID)
                        }
                    }
                    if (!targetTreeItem.isSearchedChildren) {
                        self.setChildren(targetTreeItem, next)
                    } else {
                        next()
                    }
                }
                finder(knowledgeIDList[0])
            },
            /**
             * 検索結果の閉じるボタン押下時
             */
            onClickCloseSearchResult: function () {
                this.searchedKnowledges = []
            },
            /**
             * コメント送信ボタン押下時
             */
            onClickSendNewComment: function () {
                const self = this
                const treeItem = this.selectedTreeItem

                const comment = {
                    commentNo: treeItem.comments.length == 0 ? 1 : treeItem.comments.length + 1,
                    comment: this.comment,
                    knowledgeEditionNo: treeItem.knowledge.editionNo,
                    writer: {
                        userUID: this.loggedInUserUID,
                        dateTime: this.df_currentDateTime()
                    }
                }

                const commentData = {
                    body: comment,
                    writerInfo: {
                        userName: this.loggedInUserData.userName,
                        avaterURL: this.loggedInUserData.avaterImage != null ? this.loggedInUserData.avaterImage.url : null
                    }
                }

                db.collection("knowledges").doc(treeItem.knowledge.knowledgeID).collection("comments").doc(comment.commentNo+"").set(comment).then(function(){
                    self.$store.commit("notification", {message:"コメントを投稿しました。", isError: false})
                    self.mi_writeLog("KnowledgeBankManager/onClickSendNewComment", "コメントを投稿しました。("+treeItem.knowledge.knowledgeID+",CommentNo="+comment.commentNo+")")
                    treeItem.comments.push(commentData)
                    self.comment = null
                }).catch (function (error) {
                    self.$store.commit("notification", {message:"コメントの投稿に失敗しました。", isError: true})
                    self.mi_writeLog("KnowledgeBankManager/onClickSendNewComment", "コメントの登録に失敗しました。("+error+")")
                })

            },
            /**
             * ツリーの子展開状態変更時
             */
            onOpenTreeItem: function (keys) {
                console.log("onOpenTreeItem", this.treeOpenKeys)
                const self = this
                this.treeOpenKeys = keys
                for (var key of keys) {
                    const treeItem = self.items.find((v)=>v.knowledge.knowledgeID == key && !v.isSearchedChildren)
                    if (treeItem != null) {
                        this.onSelectedTreeItem(treeItem)
                    }
                }
            },
            /**
             * 指定されたツリー項目の知識が編集可能か否かを返す
             */
            canEdit: function (treeItem) {
                if (treeItem.type == 'new') return true
                if (!this.isEditMode) return false
                if (treeItem.knowledge.lock == false) return true
                if (treeItem.knowledge.writer.userUID == this.loggedInUserUID) {
                    return true
                }
                console.log("canEdit", treeItem.knowledge.writer.userUID, this.loggedInUserUID)
                return false
            },
            /**
             * パンくずリストの項目押下時
             */
            onClickBreadcrumbsItem: function (item) {
                console.log("onClickBreadcrumbsItem", item, item.treeItem)
                this.onSelectedTreeItem(item.treeItem)
            },
            /**
             * ツリーの項目押下時
             */
            onClickTreeItem: function (treeItem) {
                console.log("onClickTreeItem", treeItem)
                const index = this.treeOpenKeys.findIndex((v)=>v == treeItem.item.knowledge.knowledgeID)
                if (index < 0) {
                    this.treeOpenKeys.push(treeItem.item.knowledge.knowledgeID)
                } else {
                    this.treeOpenKeys.splice(index, 1)
                }
                this.onSelectedTreeItem(treeItem.item)
            },
            /**
             * ツリーの項目選択時
             */
            onSelectedTreeItem: function (treeItem) {
                console.log("onSelectedTreeItem", treeItem)
                const self = this
                this.selectedTreeItem = treeItem
                if (this.selectedTreeItem.type != "new") {
                    // 記事が選択された時
                    // まだ子記事の検索を行っていなければ、検索を実行する
                    if (!this.selectedTreeItem.isSearchedChildren) {
                        // this.setChildren(this.selectedTreeItem, this.createNewKnowledgeItem)
                        this.setChildren(this.selectedTreeItem, null)
                    }
                    // 編集項目を設定
                    this.editItems.title = this.selectedTreeItem.knowledge.title
                    this.editItems.titleKana = this.selectedTreeItem.knowledge.titleKana == null ? null : this.selectedTreeItem.knowledge.titleKana
                    this.editItems.content = this.selectedTreeItem.knowledge.content
                    this.editItems.lock = this.selectedTreeItem.knowledge.lock
                    this.editItems.orderNo = this.selectedTreeItem.knowledge.orderNo == null ? 100 : this.selectedTreeItem.knowledge.orderNo
                    console.log(this.editItems)
                } else if (this.selectedTreeItem.type == "new") {
                    // "新しい知識" が選択された時
                    // 編集項目を初期化
                    this.editItems.title = null
                    this.editItems.titleKana = null
                    this.editItems.content = null
                    this.editItems.lock = false
                    this.editItems.orderNo = 100
                }
                
                // パンくずリストの設定
                this.selectedTreeItemPaths = []
                const pathSetter = function (source) {
                    console.log("pathSetter", source)
                    self.selectedTreeItemPaths.splice(
                        0, 
                        0, 
                        {
                            text: source.knowledge.title,
                            treeItem: source
                        }
                    )
                    if (source.parentTreeItem != null) {
                        pathSetter(source.parentTreeItem)
                    }
                }
                pathSetter(this.selectedTreeItem)
            },
            /**
             * "いいね" ボタン押下時
             */
            onClickNice: function () {
                const self = this
                // 選択されている記事に、過去に "いいね" を押した事があるかチェックする
                db.collection("knowledges").doc(this.selectedTreeItem.knowledge.knowledgeID).collection("nice_users").doc(this.loggedInUserUID).get().then(function(doc){                    
                    if (doc.exists) {
                        // 押した事がある時は、不可
                        self.$refs.confirm.show({
                            title: "いいね",
                            message: "いいね を押した事のある知識には いいね 出来ません。",
                            buttonYes: "戻る",
                            buttonNo: "",
                        })
                        return
                    } else {
                        // 押した事がなければ、履歴に登録して "いいね" 回数+1
                        const niceData = {
                            userUID: self.loggedInUserUID,
                            dateTime: self.df_currentDateTime()
                        }
                        db.collection("knowledges").doc(self.selectedTreeItem.knowledge.knowledgeID)
                        .collection("nice_users").doc(self.loggedInUserUID).set(niceData).then (function() {
                            self.$store.commit("notification", {message:"[いいね] しました。"})
                            self.selectedTreeItem.niceNum++
                        }).catch (function (error) {
                            self.$store.commit("notification", {message:"[いいね] の処理に失敗しました。("+error+")", isError:true})
                            self.mi_writeLog("KnowledgeBankManager/onClickNice", "[いいね] の処理に失敗しました。("+error+")")
                        })
                    }
                }).catch (function(error) {
                    self.mi_writeLog("KnowledgeBankManager/onClickNice", "[いいね] のチェック処理に失敗しました。("+error+")")
                })
            },
            /**
             * 編集ボタン押下時
             */
            onClickEditKnowledge: function () {
                this.isEditMode = true
            },
            /**
             * 登録ボタン押下時
             */
            onClickRegistKnowledge: function () {
                console.log("onClickRegistKnowledge", this.selectedTreeItem)
                const self = this
                const treeItem = this.selectedTreeItem
                if (treeItem.type == "new") {
                    // 新しい記事の時
                    this.$refs.confirm.show({
                        title: "知識の登録",
                        message: "知識を登録しますか？",
                        buttonYes: "登録する",
                        buttonNo: "しない",
                        listenerYes: function () {
                            self.registKnowledge()
                            return true
                        },
                    })
                    return
                }
                if (treeItem.knowledge.writer.userUID != this.loggedInUserUID) {
                    // 違うユーザーが知識を改訂した時
                    this.$refs.confirm.show({
                        title: "知識の改訂",
                        message: "新しい版で、知識を改訂しますか？",
                        buttonYes: "改訂する",
                        buttonNo: "しない",
                        listenerYes: function () {
                            self.registKnowledge(true)
                            return true
                        },
                    })
                    return
                }
                // 同じユーザーが知識を改訂した時
                this.$refs.confirm.show({
                    title: "知識の改訂",
                    message: "知識を改訂しますか？<br/>※版は今のままで内容が改訂されます。",
                    buttonYes: "改訂する",
                    buttonNo: "しない",
                    listenerYes: function () {
                        self.registKnowledge(false)
                        return true
                    },
                })
            },
            /**
             * 保存処理
             */
            registKnowledge: function (isNewEdition) {
                const self = this
                const treeItem = this.selectedTreeItem
                const knowledge = {
                    knowledgeID: treeItem.type == "new" ? this.createNewKnowledgeID(treeItem.parentTreeItem) : treeItem.knowledge.knowledgeID,
                    title: this.editItems.title,
                    titleKana: this.editItems.titleKana,
                    content: this.editItems.content,
                    orderNo: this.editItems.orderNo,
                    parentKnowledgeID: treeItem.parentTreeItem == null ? null : treeItem.parentTreeItem.knowledge.knowledgeID,
                    editionNo: treeItem.type == "new" ? 1 : isNewEdition ? treeItem.knowledge.editionNo + 1 : treeItem.knowledge.editionNo,
                    lock: this.editItems.lock,
                    writer: {
                        userUID: this.loggedInUserUID,
                        dateTime: this.df_currentDateTime()
                    }
                }
                console.log("editItems", this.editItems, "knowledge", knowledge)

                // DB登録後の処理
                const finisher = function () {
                    
                    if (treeItem.type == "new") {

                        // 新規の記事の時
                        // "新しい記事" の項目を削除してから、作成された記事をツリーに追加
                        const newTreeItem = {
                            type: "knowledge",
                            knowledge: knowledge,
                            parentTreeItem: treeItem.parentTreeItem,
                            isSearchedChildren: false,
                            isSearchingChildren: false,
                            children: [],
                            niceNum: 0,
                            comments: [],
                            userInfo: {
                                userName: self.loggedInUserData.userName,
                                avaterURL: self.loggedInUserData.avaterImage.url
                            }
                        }
                        console.log("newTreeItem", newTreeItem)

                        // 全体の配列に追加
                        self.items.push(newTreeItem)

                        // 親のツリー項目に追加
                        const parent = treeItem.parentTreeItem
                        if (parent == null) {
                            self.treeItems.splice(self.treeItems.length - 1, 1)
                            self.treeItems.push(newTreeItem)
                        } else {
                            parent.children.splice(parent.children.length - 1, 1)
                            parent.children.push(newTreeItem)
                        }

                        // 作成した記事を追加した親に、"新しい記事" を追加
                        self.createNewKnowledgeItem(parent)

                        // 選択を解除
                        self.selectedTreeItem = null
                        
                        // タグ作成
                        self.createTag(newTreeItem, self.$refs.editor.quill.getText())

                    } else {

                        // 記事の修正時
                        treeItem.knowledge = knowledge
                        treeItem.userInfo.userName = self.loggedInUserData.userName
                        treeItem.userInfo.avaterURL = self.loggedInUserData.avaterImage.url

                        // タグ作成
                        self.createTag(treeItem, self.$refs.editor.quill.getText())
                    }

                    self.$store.commit("notification", {message:"知識を登録しました。", isError: false})

                    // 編集モード終了
                    self.isEditMode = false
                }

                // DB登録処理
                this.mi_writeLog("KnowledgeBankManager/onClickRegistKnowledge", "知識の登録("+knowledge.knowledgeID+")")

                const register = function () {
                    db.collection("knowledges").doc(knowledge.knowledgeID).set(knowledge).then(function(){
                        finisher()
                    }).catch (function (error) {
                        console.log(error)
                        self.$store.commit("notification", {message:"知識の登録に失敗しました。", isError: true})
                        self.mi_writeLog("KnowledgeBankManager/onClickRegistKnowledge", "知識の登録に失敗しました。("+error+")")
                    })
                }

                // DB登録
                if (treeItem.type != "new" && isNewEdition) {
                    // 変更前の知識を履歴に保存
                    db.collection("knowledges").doc(knowledge.knowledgeID).collection("histories").doc(treeItem.knowledge.editionNo+"").set(treeItem.knowledge).then(function(){
                        register()
                    }).catch (function (error) {
                        self.$store.commit("notification", {message:"知識の履歴登録に失敗しました。", isError: true})
                        self.mi_writeLog("KnowledgeBankManager/onClickRegistKnowledge", "知識の履歴登録に失敗しました。("+error+")")
                    })
                } else {
                    register()
                }
            },
            /**
             * タグ作成
             */
            createTag: function (treeItem, text) {
                
                const self = this
                
                this.$store.commit("processing", {start:true, message:"知識のタグを作成しています…。"})
                
                try {
                    const creator = new WebSocket("wss://service.tomson.xyz/myfield_tag_creator")
                    const request = {
                        knowledgeID: treeItem.knowledge.knowledgeID,
                        text: text
                    }
                    creator.onopen = function (e) {
                        console.log("onopen", e)
                        creator.send(JSON.stringify(request))
                    }
                    creator.onmessage = function (e) {
                        self.$store.commit("processing")
                        creator.close()

                        const result = JSON.parse(e.data)
                        console.log("onmessage", result, result.tags.length)

                        switch (result.result) {
                            case "success":
                                self.$store.commit("notification", {message:"知識のタグが作成されました。"})
                                console.log(treeItem)
                                break;
                            default:
                                self.$store.commit("notification", {message:"知識のタグ作成に失敗しました。", isError: true})
                                self.mi_writeLog("KnowledgeBankManager/createTag", "知識のタグ作成に失敗しました。("+result.error+")")
                                break;
                        }
                    }
                    creator.onclose = function (e) {
                        self.$store.commit("processing")
                        console.log("onclose", e)
                    }
                    creator.onerror = function (e) {
                        console.log("onerror", e)
                        creator.close()
                        self.$store.commit("processing")
                        self.$store.commit("notification", {message:"知識のタグ作成に失敗しました。", isError: true})
                        self.mi_writeLog("KnowledgeBankManager/createTag", "知識のタグ作成に失敗しました。("+e+")")
                        return
                    }
                } catch (error) {
                    this.$store.commit("processing")
                    this.$store.commit("notification", {message:"知識のタグ作成に失敗しました。", isError: true})
                    this.mi_writeLog("KnowledgeBankManager/createTag", "知識のタグ作成に失敗しました。("+error+")")
                }
            },
            /**
             * 指定された親ノードの項目の子記事を検索してセット
             */
            setChildren: async function (parentTreeItem, completed) {
                console.log("setChildren", parentTreeItem)
                if (parentTreeItem != null) {
                    parentTreeItem.isSearchedChildren = true
                    parentTreeItem.isSearchingChildren = true
                }
                const self = this
                db.collection("knowledges").where("parentKnowledgeID", "==", parentTreeItem == null ? null : parentTreeItem.knowledge.knowledgeID).orderBy("orderNo", "asc").orderBy("titleKana", "asc").get().then(function(snapShot) {
                    console.log(snapShot.size)
                    if (snapShot.size == 0) {
                        if (parentTreeItem != null) parentTreeItem.isSearchingChildren = false
                        if (completed != null) completed(parentTreeItem)
                    } else {
                        var addedNum = 0
                        snapShot.forEach(function(doc) {
                            const knowledge = doc.data()
                            const treeItem = {
                                type: "knowledge",
                                knowledge: knowledge,
                                parentTreeItem: parentTreeItem,
                                isSearchedChildren: false,
                                isSearchingChildren: false,
                                children: [],
                                niceNum: 0,
                                comments: [],
                                userInfo: {
                                    userName: "",
                                    avaterURL: ""
                                }
                            }

                            db.collection("knowledges").doc(knowledge.knowledgeID).collection("comments").get().then(function(refComments){
                                refComments.forEach(function(docComment){
                                    const commentData = {
                                        body: docComment.data(),
                                        writerInfo: {
                                            userName: "",
                                            avaterURL: ""
                                        }
                                    }
                                    treeItem.comments.push(commentData)
                                    self.mi_userData(commentData.body.writer.userUID, commentData.writerInfo)
                                })
                            }).catch (function(error){
                                self.mi_writeLog("KnowledgeBankManager/setChildren", "コメント取得に失敗しました。("+knowledge.knowledgeID+")("+error+")")
                            })

                            self.items.push(treeItem)

                            self.mi_userData(knowledge.writer.userUID, treeItem.userInfo)

                            self.createNewKnowledgeItem(treeItem)

                            db.collection("knowledges").doc(knowledge.knowledgeID).collection("nice_users").get().then(function(snapShot) {
                                console.log(treeItem)
                                treeItem.niceNum = snapShot.size
                            })

                            if (parentTreeItem == null) {
                                self.treeItems.push(treeItem)
                            } else {
                                // parentTreeItem.children.push(treeItem)
                                parentTreeItem.children.splice(parentTreeItem.children.length-1, 0, treeItem)
                            }
                            addedNum++
                            if (addedNum == snapShot.size) {
                                if (parentTreeItem != null) parentTreeItem.isSearchingChildren = false
                                if (completed != null) completed(parentTreeItem)
                            }
                        })
                    }
                }).catch (function(error) {
                    self.mi_writeLog("KnowledgeBankManager/setChildren", "子知識の検索に失敗しました。(parent="+(parentTreeItem != null ? parentTreeItem.knowledge.knowledgeID : "")+")("+error+")")
                })
            },
            /**
             * 指定された親ノードの項目に、"新しい記事" の項目を追加
             */
            createNewKnowledgeItem: function (parentTreeItem) {
                const treeItem = {
                    type: "new",
                    knowledge: {
                        knowledgeID: parentTreeItem == null ? "new" : parentTreeItem.knowledge.knowledgeID + "-new",
                        title: parentTreeItem == null ? "新しい知識を入力" : "["+parentTreeItem.knowledge.title + "] の新しい知識を入力",
                        titleKana: null,
                        lock: false
                    },
                    isSearchedChildren: false,
                    isSearchingChildren: false,
                    children: [],
                    parentTreeItem: parentTreeItem,
                    niceNum: 0,
                    comments: [],
                }

                console.log("createNewKnowledgeItem", treeItem)

                if (parentTreeItem == null) {
                    this.treeItems.push(treeItem)
                } else {
                    parentTreeItem.children.push(treeItem)
                }
            },
            /**
             * 指定された親項目に対して、新しい知識IDを作成して返す
             */
            createNewKnowledgeID: function (parentTreeItem) {
                var targetArray = null
                if (parentTreeItem == null) {
                    targetArray = this.treeItems
                } else {
                    targetArray = parentTreeItem.children
                }
                var id = ""
                if (targetArray.length == 0) {
                    id = "00001"
                } else {
                    var n = Math.max(...targetArray.map(
                        function (item) {
                            const values = item.knowledge.knowledgeID.split("-")
                            const v = values[values.length - 1] != "new" ? values[values.length - 1] * 1 : 0
                            return v+1
                        }
                    ))
                    id = ("00000" + n).slice(-5)
                }
                if (parentTreeItem != null) {
                    id = parentTreeItem.knowledge.knowledgeID + "-" + id
                }
                return id
            }
        }
    }
</script>

<style scoped>
    img {
        max-width: 100%;
    }

    .balloon2-left {
        position: relative;
        display: inline-block;
        margin: 1.5em 0 1.5em 15px;
        padding: 0px 10px;
        min-width: 120px;
        max-width: 100%;
        color: #555;
        font-size: 16px;
        background: #FFF;
        border: solid 3px #555;
        border-radius: 8px;
        box-sizing: border-box;
    }

    .balloon2-left:before {
        content: "";
        position: absolute;
        top: 24px;
        left: -22px;
        margin-top: -12px;
        border: 12px solid transparent;
        border-right: 12px solid #FFF;
        z-index: 2;
    }

    .balloon2-left:after {
        content: "";
        position: absolute;
        top: 24px;
        left: -28px;
        margin-top: -14px;
        border: 14px solid transparent;
        border-right: 14px solid #555;
        z-index: 1;
    }

    .balloon2-left p {
        margin: 0;
        padding: 0;
    }
</style>
